var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.41 239.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6c4c35;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#fff;}.cls-3{fill:#1c2c58;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "saving space") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.63,34.08a213.58,213.58,0,0,0-7.82,35.58c-.53,4.12-.57,9-1.49,12.47-.78,2.91-3,5.07-3.72,8.31-.7,3.08-1.51,7.92-1.12,11.55.25,2.37,1.55,3.67,1.86,6,1.07,8-.58,17.41,0,26.34.56,8.51,1,16.38,2.61,24-2.86,6.42.05,17.27,4.1,20.79,2.45,7.93,4.92,15.48,7.82,22.64s6.62,13.92,8.93,21.7c6.12,12.41,19.81,13.25,35.37,14.79,18.76,1.85,38.78.75,56.23-.93,15.69-1.51,29.08-1.28,34.25-14.78.89-2.3.69-5.05,1.49-7.39,1.33-3.86,3.82-7.33,5.59-11.09,5.43-11.58,9.92-23.33,12.28-38.8,2.86-3.71,5.27-10.53,4.1-18-.42-2.72-1.56-2.92-1.86-5.54-.54-4.7.6-11.24.37-17.09s-1.44-12-1.11-16.64c.13-2,1-4,1.11-6a54.48,54.48,0,0,0-1.86-15.24C408.88,83.64,406.84,81,406,78c-4.59-17.15-7.59-33.44-13.4-48.5,2.47-5.39-1.63-12.12-2.61-17.56-35.71-15.17-96.7-16.73-131.81.46C255.55,18.16,249.77,25.87,252.63,34.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.79,13.3c-2.43,1.6-4.48,3.68-7.44,4.62C312.67,16.19,313.54,12.64,317.79,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.55,17c-15.21.93-30.48-.33-46.17.46-1.88-.65,2-1.32,1.49-3.23-1-1.23-1.84.43-3,.46-.07-.39.14-.43.37-.46C337.16,12.54,354.89,15.3,369.55,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310,13.76c-2,1.27-3.21,3.4-5.58,4.16-1.67,0,.51-1.36.37-2.31-.13-.61-.66-.73-.74-1.39-3.9.56-4.49,5.22-9.32,4.62C296.78,13.4,303.36,13.56,310,13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.22,14.68c.81.82-2,4.82-4.47,4.62A16.56,16.56,0,0,1,293.22,14.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.26,15.61c.91.79-2,4.5-4.1,4.62C284.44,18.58,285.33,16.45,287.26,15.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.67,16.53c.84,1-2.32,4.75-4.47,5.08A17.06,17.06,0,0,1,281.67,16.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.2,17.45c.87,1-2.71,4.26-4.46,5.09A47.5,47.5,0,0,1,277.2,17.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.41,19.77c1.64.59-1.7,2.33-1.87,3.69-1-3.17-3.7.41-4.84,1.39-.94-.62.55-2.05.38-3.24C262.19,21,264.55,20.7,266.41,19.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.93,23.92h6.7c-.15.89-1.44.37-1.12,1.85,2.16-1.8,5.45-2.18,9.31-1.85-3.78,3-9.34,3.81-12.28,7.86A35.2,35.2,0,0,1,350.93,23.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.37,24.85c-7.13,4.71-16.36,6.8-22,13.39,8.12-1.32,15.53-7.52,23.45-10.62-6.88,5.78-15.69,9.16-23.08,14.32-.54-3.34-1.57-6.06-2.23-9.24C362.58,31.35,366.8,21.56,377.37,24.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.69,24.38c1.55,6,5.24,14.08,4.48,19.87,2.79,5.78,3.05,14.68,4.46,22.17-10.38.22-20.75.44-30.53,1.39-1.24-12.93-1.27-27.37-2.23-40.65C333.19,26.71,340.55,25.06,348.69,24.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.42,27.62c.51.91.36,2.64.75,3.69-1.06,1-2.8,1.16-3.73,2.31C381.44,31.11,382.79,25.49,387.42,27.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.26,27.62c.94,12.7,1.57,28.22,1.86,40.19-9.93.15-18.66,1.79-28.3,2.31.95-14.39,2.23-28.35,5.22-40.19A113.41,113.41,0,0,1,322.26,27.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.06,30.39c-2.08,12.67-4.51,24.89-4.84,39.73-9.42,3.25-21.84,2.78-30.91,6.47,2.16-15,4.15-30.27,7.82-43.43A149.11,149.11,0,0,1,298.06,30.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.46,34.55c-7.36,5.81-16.66,9.2-23.83,15.24a12.1,12.1,0,0,1-1.12-5.54c8.39-3.77,15.9-8.62,23.84-12.94C380.63,32.5,380.72,33.93,381.46,34.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.65,39.17a8.73,8.73,0,0,1-3,1.38c-.19-1.92-1.31-2.69-1.49-4.61C387.88,32.82,389.53,34,389.65,39.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.44,41.48c-6.18,5.57-14.74,8.19-21.22,13.39,2.75,2.25,7.46-2.24,10.8-4.15,3.75-2.16,7.9-3.94,10.79-6.47.95.37,1,1.9,1.49,2.77-7.95,6.3-18,10-26.06,16.17-1.7-2.82-1.62-7.84-2.61-11.55a160.5,160.5,0,0,0,24.58-13.86C383.54,38.29,383.45,40.55,384.44,41.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.77,46.56c-.31-1.36-.94.6-1.86,0,.14-2-1.06-2.38-1.12-4.16,1.07-.21,1.17-1.63,2.61-1.39.61,8,4.9,13.92,4.47,21.72-.93-.26-1.86-2.89-1.12-3.7-2-3.25-3-7.66-4.1-12A1.56,1.56,0,0,1,390.77,46.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.54,54.87c-10,2.66-16.44,13.8-28.3,11.09,1-3.1,4.16-3.12,6.33-4.16a131.86,131.86,0,0,0,20.11-12C388.13,50.46,388.36,52.64,388.54,54.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.28,56.72c.75.62.83,2.05,1.12,3.24-6.94,1.84-10.41,8.94-18.62,7.85C376.79,63.09,384.17,61.31,389.28,56.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.89,64.11c-1.5,2.62-4.69,3.11-5.59,6.47-1.82-1-4.31-1.12-6.33-1.85,3.19-2.66,7.58-3.84,10.43-6.93C391.78,61.48,391,63.78,391.89,64.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.61,65c1.54,1.94,1.61,5.7,2.24,8.77C397.12,71.1,395.1,67.76,395.61,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393,67.81a16.83,16.83,0,0,0,1.48,4.62c-1.67.83-4.28-1.14-6.32-1.39C389.8,70,390.92,68.3,393,67.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.29,87.21c.95,3.13,1.24,7.09,1.87,10.62-24.64-8.75-56.28-13.57-87.51-11.08,8.77,3.44,21.88,1.5,32,3.23-15.66.58-31.58.85-46.17,2.78-1.39-.56,1.5-3.24,3-3.24a3.61,3.61,0,0,0-.37,2.31c2.88.19,2.46-3.72,6-2.77.22-1.61-1.15-1.68,0-4.16-2.21-1-2.76,2.17-4.47,2.77-4.05,1.43-9,.06-13,.47-18.3,1.8-38.27,4.74-52.5,11.08a106,106,0,0,1,1.49-11.08c26.19-10.07,66.05-15.67,100.53-12.48C367.69,77.66,390.14,79.37,405.29,87.21Zm-29.78-2.77c.65.41.94,1.29,2.23.92a4.7,4.7,0,0,0,.37-2.77C377,81.26,375.14,81.59,375.51,84.44Zm5.95,1.85c2.54,2.72,2.94-4.25.38-1.85C381.28,84.52,381.49,85.55,381.46,86.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304,90c-1,1.13-1.3,3-3,3.23C301.6,91.61,301.91,89.67,304,90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.17,90.44c-.9,1.5-1.72,3.1-4.09,2.77C295.89,91.61,297,90.34,299.17,90.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.47,90.9C292,92.84,291,94,288.75,93.68A4.39,4.39,0,0,1,292.47,90.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.89,91.37c.92,1.78-2.13,2.58-3.35,3.23-1.05-.74.8-1.72.74-2.77C285.05,91.55,286.72,92.4,286.89,91.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.92,100.61c-8.09-1.43-19-4.76-30.53-6.93-1.29-.25-4.49-.86-6.7-1.39.24.06-2.3-.85-2.24-.46-.19-1.18,13.53.58,2.61-.46C380.42,92.55,394.09,97.66,404.92,100.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.93,92.29c-.89,1.36-1.63,2.91-3.35,3.24C278.62,94.36,278.87,92.2,280.93,92.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.6,93.68c-1.12,1.07-1.55,3-3.36,3.23C271.89,95.25,272.63,93.7,274.6,93.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.36,99.68c0,18.5,1.25,35.4,1.48,53.59-11.35,1.16-21.39,3.94-33.51,4.16-2-16.79-1-38.16-.74-56.36C304.1,100.4,315.87,98.85,326.36,99.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.36,99.68c2.93,14.22,4.17,30.56,4.09,48.51-12.23.84-22.7,3.86-35,4.62-.77-17.84-1.31-35.95-2.23-53.59C339.4,99.21,350.67,99.08,361.36,99.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.06,107.07c-.34-1.25-1.17.65-2.24,0-.4-2.42-1.08-4.5-1.49-6.93a203,203,0,0,1,28.31,3.24c-7,4.57-15.89,6.78-21.23,13.4,4.09-1,8.6-4.07,13-6.47s8.73-6,13-5.08c-4,3.53-9.14,5.63-13.77,8.31s-9.37,4.95-13,8.78c9.62-2.09,17.8-9.95,27.56-13.4-.31,1.31.52,1.2.37,2.31-4.57,3.93-10.06,6.69-15.27,9.7a148.15,148.15,0,0,0-14.89,9.7c-.18-5.63-.41-11.18-1.49-15.7,5.65-4.07,12.61-6.53,17.13-12-7,1.77-11.59,6.58-17.5,9.71C366.47,110.07,365.42,107.07,368.06,107.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.73,101.07a442.88,442.88,0,0,0-.38,56.82c-9,0-17.23.79-26.43.46a209.14,209.14,0,0,1-4.84-54C270,102.45,281.08,102,291.73,101.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.72,104.76c2,1,1.12,6.41,1.12,9.71,0,16.25,1.66,31.3,4.84,43.42a111.85,111.85,0,0,1-14.14.92c-2.68-14.59-3.7-33-2.61-50.82A86.32,86.32,0,0,1,256.72,104.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.94,106.61c1.75,0,3.8-.4,3.72,1.85-.16,1.79-2.11,1.38-3.35,1.85A10.82,10.82,0,0,1,401.94,106.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.66,117.24c-.49-1.18-1.65.67-2.6.46-.5-1.39-.38-3.54-.37-5.54,1.56.09,1.56-1.76,3-1.85.41,4.27.35,9.12.75,13.39-1.22,0-1.42,1.32-3,.93C403,120.71,403,118.11,405.66,117.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399,115.39V120c-11,5.45-20.74,12.45-30.53,19.4v-6.93C378.91,127.16,388.46,120.68,399,115.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.34,126.94c-9,6.18-19.92,10.09-27.19,18.47,9.7-4,18.61-11.4,27.19-15.24-.38,5.28-5.71,6.65-8.94,8.78-6.26,4.13-12,9.07-22,9.24-.2-2.63-.46-4,0-6.47C379,136,388.7,129.3,398.59,122.78,400.1,122.6,399,125.66,399.34,126.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406,124.63c.84.49.14,2.9.37,4.16-.93.38-1.46,1.26-2.61,1.38.18-1.46-.67-1.63-.37-3.23C404.37,126.25,405.48,125.78,406,124.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406,130.63c.86,2.78.12,7.54.37,11.09-1.14-.33-1.09.8-2.24.46-.8-2.23-.17-6.25-.37-9.24C404.65,132.3,405.25,131.34,406,130.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399,136.18c.75,1.85.72,4.65,1.49,6.47-4.38.26-8.54.79-12.66,1.38C391.33,141.18,395.61,139.25,399,136.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.16,149.11c2.18-.39.67,3.79,1.11,5.54-13.47,5.15-30.91,5.39-45.8,8.78-2.2.47-.57-1-1.86-1.38-1.85.06-3.29,2.3-5.21,2.77-1,.23-2.45-.65-4.1-.46-2.71.3-4.55,3.33-6.7.46-5.57,3.84-16.82,3.66-27.18,4.16-15.67.75-32.7,1.25-48.78.46-7.93-.4-15.59-.22-21.59-2.77,1.59-4,6.29-1.94,8.56-1.85a499.07,499.07,0,0,0,108.72-8.32c12.68-2.41,25-5.26,36.87-6.93C403.21,149.29,405.14,150.06,407.16,149.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.11,163.43c1-.14,1,1,1.12,1.85-1.34,0-2.15.72-3.35.93C376.35,164.94,377.37,164.36,378.11,163.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M374,164.36c-1.77,1.35-3,3.36-5.59,3.69C369.9,166.33,371.14,164.33,374,164.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.69,165.28a9.7,9.7,0,0,1-7.82,4.62C362,167.78,363.83,165.27,367.69,165.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.49,166.67c-1.64,2.57-3.81,4.5-7.44,4.61C353.92,169,355.83,166.74,359.49,166.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.05,168.05c-2.07,1.74-3.19,4.68-6.7,4.62C347.26,170.74,348.4,167.84,352.05,168.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.47,168.05c-8.36,4.72-18.83,6.82-25.69,13.4-.86-1.71-.13-5.38-.37-7.86C380.18,171.85,388.66,169.74,397.47,168.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.6,169c1.13,1.44-1.88,1.65-1.12,4.15-1.76-.34-2.56.52-4.09.46A7.8,7.8,0,0,1,344.6,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.69,169.44c-.45,2.06-.5,4.61-2.24,5.08C400,173.2,400.72,169.31,402.69,169.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339,169.9c-1,4.88-5.17,4.3-8.56,4.62-25.32,2.35-56.67,1.88-79.68-2.31C279.82,172.29,310.57,173.37,339,169.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.61,172.21c.92,1.47-.77,3.65-1.12,5.08-8.61,3.18-15.86,8-23.83,12,.54-1.49.36-3.88.38-6C378.82,179.09,387.56,176.08,395.61,172.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365.82,175.44c-1,12.45-2.21,24.66-3.72,36.5a265.94,265.94,0,0,1-29.41,6c-.42-12.26-1.08-24.22-1.49-36.49C343.28,180.12,353.63,176.64,365.82,175.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M400.08,177.29c.8,2.39-1,5.5-3,6C396.75,181.47,398.33,178.05,400.08,177.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.92,196.69a12.46,12.46,0,0,0,.37-4.16c6.9-4.37,14.86-7.43,22-11.54,1.82.94-.76,3.81-1.12,5.08A191.8,191.8,0,0,0,369.92,196.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329,181.45c.15,12.6,1.24,24,1.12,37-9,1.12-19.11.94-28.3,1.85-2.87-11.06-4.58-23.57-5.58-37C307.82,183.55,317,180.72,329,181.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.12,181.91a50.35,50.35,0,0,0,13.41,1.38c3.09,12.64,8.26,22.7,11.54,35.11-3.53-.86-8.36-.1-11.54-1.38C262.74,205.7,257.84,194.54,254.12,181.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.5,183.29h23.09c1.46,12.52,3.32,24.53,5.21,36.5-5.8.12-10.53-1.1-16-1.39C278.79,206.59,273.3,196.61,270.5,183.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.47,185.61c.29,2.2-1.38,6-4.09,6C394.25,189,395.23,186.52,397.47,185.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390,189.76a14.11,14.11,0,0,0-1.12,3.7c-6.59,3.53-14,6.1-19.73,10.62-1.08-1.52.72-3.4.37-5.54C377,196.37,382.88,192.29,390,189.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394.12,193.92c1.09.86-1.09,5.32-3.35,5.08A6.27,6.27,0,0,1,394.12,193.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.05,197.62c-1.67,6.71-9.45,5.83-13,10.16,3.34.09,6.86-3.46,10.79-4.16-.61,1.54-1.24,3.08-1.86,4.62-5.5,1-10.44,2.75-16.38,3.23.65-1.81,1.12-3.84,1.86-5.54C374.62,203.14,380.62,200.11,387.05,197.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.52,200.85c-1.23,2.48-1.42,6.25-4.47,6.47C388.45,205.05,388.51,201.13,391.52,200.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.73,222.1c-1.52,1.81-2,4.92-5.59,4.16C357.22,223.84,358.8,220.83,361.73,222.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377,221.64c-.47,1-.59,2.34-1.86,2.3C375.61,223,375.73,221.61,377,221.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.4,222.1a6.07,6.07,0,0,1-5.59,4.62C350.6,223.84,351.76,221.43,355.4,222.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.69,222.1c-1.35,1.72-1.91,4.41-5.22,3.69C363.83,224.09,364.45,221.47,367.69,222.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.53,222.1c-.59,1.73-1.35,3.26-3.73,2.77C369.59,223.38,370,221.47,372.53,222.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.69,222.56c-.88,2.6-2,4.93-5.58,4.16C344.6,224.87,345.35,222.1,348.69,222.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.36,223c-1.31,1.45-1.45,4.35-4.09,4.16C339.49,225.61,339.89,223,342.36,223Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.65,223.48c.49,5.36-8.3,3.9-13,4.16-10.56.58-24.95.52-34.26-.92C307.24,225.79,323.84,225.75,338.65,223.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.48,226.26c-.86,1.38-.52,4.27-3,3.69C376.51,228.74,376.62,226.41,378.48,226.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.18,227.64c-.66,2.27-1.51,4.29-4.47,3.7C365.54,229.29,366.39,227.27,369.18,227.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.22,228.1c-.87,2.62-2.36,4.46-5.59,4.16C358.82,230,360.36,228.25,363.22,228.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.32,229a326.3,326.3,0,0,0,59.21.92c-2,6-9.35,3.7-14.15,3.7C309.27,233.65,292.11,233.36,278.32,229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.89,228.56c-1,2.35-2.1,4.49-5.22,4.16C352.92,230.73,353.5,227.91,356.89,228.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.93,229c-1.09,1.88-2.07,3.89-4.47,4.15C345.29,231.88,347.78,228,350.93,229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.6,229.49c-.25,1.69-1.41,2.26-1.86,3.69h-4.09C340,231.12,340.88,228.57,344.6,229.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.93,17.92C350.17,8,300.39,7.09,264.17,17c4.64-4.92,19.67-9.65,31.65-9.7,7.76,0,16.4,1.39,25.32,1.39,8.65,0,17.83-.73,26.07,0,10.67,1,20.05,2.62,31.27,4.16C381.15,13.2,385.68,13.11,385.93,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.62,18.84c1.15,1.1-2.5,3.89-3.72,5.08C268,22.68,270.18,20,271.62,18.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.49,99.68c3.67-2.52,9.16-2.81,13.41-4.62,1.39.29-1.76,2.26-2.23,3.24C261.5,98.21,258.2,99.2,254.49,99.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.4,161.58c-.25,1.09-4.24,1.52-6,2.31C385.12,161.51,388.53,162.5,390.4,161.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.64,226.72c.38.8-1,3.33-2.23,3.69A6.6,6.6,0,0,1,373.64,226.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.15,33.62c.69,3.11-.79,6.56-1.48,10.17-2,10.38-3.77,22.52-5.59,33.26a62.22,62.22,0,0,1-9.31,3.23c.37-16.94,2.5-31.69,7.07-43.42,1-.41,2.27-.58,3-1.39-1.78,11.19-7.49,21.5-6.7,37.42,3.1-12.94,5.32-27,9.68-38.34C265.07,34.43,265.59,33.38,267.15,33.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.25,179.69c-.41-5.88-.22-12.74-1.72-17.16-1-2.82-2.92-4.84-4.84-6.87-1.31-1.38-3.69-2.82-4.21-4.21-.8-2.14-.71-5.08-.94-7.65s-.72-5.44-.31-8c.15-.9.77-1.82.94-2.81.43-2.59-.06-5.36.31-8-1.51-1.28-4.27-1.55-7-1.25-1.4.16-4.19.77-5,1.88-1.11,1.52-.77,5.61-.16,7.8.29,1,1.1,1.48,1.25,2.18.37,1.73-.16,5.7-.16,8.43,0,3,.54,6.37,0,8.27s-3,2.82-4.68,4.52A19,19,0,0,0,.82,163c-1.1,3-.78,6.75-.78,10.46,0,2.63,0,5.26.16,8,.42,10.39.47,21,.93,31.21C1.52,221,1.07,228.17,5.5,232c2.61,2.22,7.47,2.93,12.33,3,4.5,0,9.53-.6,11.7-2.81,2.81-2.86,2.34-10.78,2.65-15.91.4-6.6-.1-13-.15-18.41C32,191.67,31.67,185.91,31.25,179.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.37,125.86c.48,0-.1,1,.93.78-.69.48-1.56-.19-2.49,0C11.05,126.11,11.84,126.11,12.37,125.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.2,126a6.52,6.52,0,0,1-3.58.62C14.67,126.19,15.65,125.55,17.2,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.8,128.2a7.94,7.94,0,0,1-4.84.16C12,127.69,14.38,128.66,15.8,128.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.08,128.51a3.89,3.89,0,0,1-2.5.94A4.2,4.2,0,0,1,19.08,128.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.56,129c.58.78,2.39.32,3.12.94C12,130.5,10,129.73,9.56,129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.64,129.45c.17.58-.52.31-.62.62C14.54,129.78,15.2,129.33,15.64,129.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.3,129.61h.94c.14.66-.37.66-.94.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.77,130.07c.34.07.06.77.15,1.1a4.33,4.33,0,0,1-2.34.93v-1.4A14,14,0,0,0,18.77,130.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.72,130.54c.38,0,.48.25.78.31v1.25C9.72,132.09,9.7,131.34,9.72,130.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.33,131c.51.07.51,1.56-.31,1.25C15,131.72,14.94,131.14,15.33,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.43,131.17c.48.09,1.11,0,1.09.62s-.59.45-1.09.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.24,131.32c.15.77-.17,1.08-.94.94C13.16,131.49,13.47,131.18,14.24,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.61,132.88c-.11.83-1.51.37-1.87.94C16.14,132.91,18,133.13,18.61,132.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.18,133c.38.14.42.63.47,1.09C10,134.23,10.21,133.54,10.18,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.59,133.35h.78c-.11.48.16.57.15.94h-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.3,133.35a1.32,1.32,0,0,1,.94.16v.78H13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15,133.35h.47c0,.45,0,.85-.47.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.36,135.38c.13,0,.15.06.16.15,0,1.94.21,4.06.31,6.4.06,1.46.78,3.33-.31,4.06-.84-2.9-.5-7-.78-10.46C17.06,135.6,17.15,135.43,17.36,135.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.49,135.85c1,2.8.18,7.51,1.25,10.3a16.79,16.79,0,0,1-5.15.46A104.49,104.49,0,0,1,11.9,136,16.58,16.58,0,0,0,15.49,135.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,146.77c.49,0,.27.77.32,1.25a11.28,11.28,0,0,1-6.71.31c1.61-.57,3.81-.55,5.46-1.09a.84.84,0,0,1,.15.62C17.36,147.39,17.52,146.93,18,146.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.92,151.76c-1.43,1.79-5.18.94-7.33.94.31,1.57,3.93,1.15,6.24,1.25,1.89,3.2,3.61,6.58,5.3,10-5.26,1.68-11.95,1.24-17.47.16-.46.13.36.23.16.62a6.1,6.1,0,0,0-1.72-.16c.42,1.4,3.41,2.56,5.46,2.81,1.87.23,4-.17,6.08,0a26.19,26.19,0,0,0,.79,6.24,3.09,3.09,0,0,1-1.41.32c0-2.1-.36-3.9-.47-5.93-.63,1.4-.36,4.49.16,5.77-4.28.12-9.88.2-12.95-1.4.12-4.6-.2-8.1,1.71-10.46.65-.79,1.74-1.8,2.66-2.81,1.46-1.6,2.69-2.58,3.9-4.05a10.51,10.51,0,0,0,1.56-5,12,12,0,0,0,6.86-.63A11.54,11.54,0,0,1,18.92,151.76ZM3.47,164.24a.67.67,0,0,0,.63-1.09A.66.66,0,0,0,3.47,164.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.69,161.75c.58.2.58,1,.94,1.4C25.1,163.52,24.94,162.18,24.69,161.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.13,165c.18,0,.27,0,.31.16a7.32,7.32,0,0,1,.31,2.81c.12.69-.24,1.06-.16.15A19.66,19.66,0,0,0,28.13,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.66,165.18c.15,0,.12.19.15.31a16.32,16.32,0,0,0-.15,3.12c-.13,1.19-.21-.66-.16-1.09-.32-.4.06-1.51-.31-1.87C27.14,165.29,27.64,165.47,27.66,165.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.1,165.8h.47c-.21,2.5.34,5.06,0,7.18C26.32,170.86,25.68,167.55,26.1,165.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.85,166.12h.47c0,2.34-.06,4.73.15,6.86A14.7,14.7,0,0,1,24.85,166.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.29,166.43h.47c.13,1.68.13,4.58.31,6.71C23.46,171.25,23.59,168.63,23.29,166.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.67,166.58a40.43,40.43,0,0,0,.31,6.56H21.73c-.08-2.22-.28-4.3-.47-6.4C21.86,166.82,22,166.46,22.67,166.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.48,166.9c.24,2,.22,4.25.47,6.24-.62-.06-.87.27-1.56.15-.06-2.23-.43-4.14-.62-6.24C19.1,166.76,19.91,167,20.48,166.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,167.05a23.85,23.85,0,0,0,.63,6.24c-.57.05-.72.53-1.41.47-.13-2.31-.68-4.21-.77-6.55A5.28,5.28,0,0,1,18,167.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.92,174.07c.73.2,1.44.43,2.18.63a6.4,6.4,0,0,1,.16,1.87,5.75,5.75,0,0,1-2.19-.94A4,4,0,0,0,1.92,174.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.59,174.07c.5-.13.33.41.63.47C29.05,175.28,28,174.55,28.59,174.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,174.54c0,1-1.53.91-2.34,1.09l-2.65.63c.12-.59-.19-.75-.16-1.25C24.53,174.94,26.55,174.38,28,174.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5,174.85c.29,0,.33.19.63.16v1.71C4.93,176.63,5.09,175.63,5,174.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.44,175c.54-.13.6.23,1.09.15,0,.65-.27,1-.15,1.72C6.13,177.19,6.48,175.9,6.44,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.26,175h.47c-.1.47.2,1.34-.16,1.56C21,176.53,21,175.38,21.26,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.17,175.16c-.12.75.24,1,.16,1.72-3.81.51-7.46.12-11.86.16v-1.72C12.65,175.51,16.09,175.33,20.17,175.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.37,175.79c.14,0,.15.06.16.15a295.67,295.67,0,0,1,.62,34.17c-.41-11.23-1.22-22.91-1.24-34A1,1,0,0,1,29.37,175.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.81,176.41c.13,0,.16.16.32.16,0,11.69.63,22.77.78,34.32-7.42,2-20.21,2.36-25.9-1.4-.95-10.18-.58-21.68-.94-32.45C9.23,179.06,21.44,179.16,27.81,176.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.16,211.52c.14,0,.15.06.16.15a46.28,46.28,0,0,0,6.4,1.88c.51.11,1.59-.44,1.56.62-2.18.34-6-.57-8.12-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.06,212.3c-.23.86-1.46.72-2.18,1.09C26.84,212.26,28.4,212.73,29.06,212.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.63,213.08c-.11.47.27.46.16.93-.46,0-.48.36-.94.31.08-.49-.28-.55-.16-1.09A1.35,1.35,0,0,1,25.63,213.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.91,213.55v1.09c-1.66.2-3.24.49-5,.62C20.54,214.74,21.8,213.05,23.91,213.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.21,213.7H13v.94C12.26,214.79,12.12,214.36,12.21,213.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.08,213.7h4.37a11.9,11.9,0,0,1-4.37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.28,223.84c-.33-2.74-.14-6-.62-8.58.23-.18.64-.19.78-.47C28.9,217.08,29.09,221.79,28.28,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.16,215.11c2.56.28,5.63,1.32,8.43,1.56.7.06,1.47-.12,2.18,0,1,.16,2,.84,3.12.93,1.55.12,2.78-.29,4.37-.31-.22,1.89.43,3.73,0,5.3-.93-.26-.64-1.75-.78-2.81-.46.58.15,2.24-.31,2.81-1.83-.09-.75-3.1-1.56-4.21-.33,1.11.2,2.71,0,4.21-4,.52-8.47.59-11.7,1.88,3.72.34,7.84-1.1,11.86-.47-.09,1.69.09,3.13.15,4.68-4.32-.25-9.51-.17-12.64-1.41-2.38-.94-2.25-2.14-2.65-5.61A35,35,0,0,1,3.16,215.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.41,215.73c.62,1.77.31,5.3.16,7.33a37.35,37.35,0,0,1-.63-7.18C26.16,215.9,26.38,215.91,26.41,215.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.54,216.35c.4,1.58.77,4.83.15,6.4-.61-1.68-.45-4.12-.62-6.24C24.29,216.52,24.51,216.53,24.54,216.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.2,217h.47a14.55,14.55,0,0,1,.31,5.61c-1.21-.77-.53-3.42-.78-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.54,223.84h.79c0,1.63.46,3.58.15,5C18.94,228.49,19.77,225,19.54,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.11,223.84c.25,0,.26.15.46.16-.32,2,.64,4.78-.31,5.46C21.47,228,21,225.2,21.11,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.51,224H23c.37,1.53.61,4.76,0,6.24C22.33,228.65,22.79,226,22.51,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.54,224.47c.77.8.77,4.65,0,5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.25,225.09c.88.47.47,3.73.32,4.21C25.85,228.51,26.45,226.4,26.25,225.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.13,226.18c.32.52,1.07,2.28,0,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.26,227.12c2.42,1.63,6,2.11,9.82,2.34-.13.49-.73.51-.93.93C9.58,229.91,5.65,229.78,4.26,227.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.64,229.3a.88.88,0,0,1-.78,1.09C19.73,229.64,20.05,229.34,20.64,229.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.92,229.61c-.44.39-.76.91-1.56.94-.14-.38.7-.8,0-.78A2.29,2.29,0,0,1,18.92,229.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.89,229.61c-.57.31-.92.85-1.87.78C15.27,229.76,15.85,229.45,16.89,229.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.13,230.39c.19.67-1.23,1.07-2,1.25C26.27,230.72,27.7,231.06,28.13,230.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.13,230.71c1.58,0,3.41,1.16,5.61,1.09,0,.36,0,.59.32.62A9.77,9.77,0,0,1,6.13,230.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.16,231.64c0,.56-.51.63-1.09.63a.86.86,0,0,0,.15-.63C24.76,231.77,24.88,231.35,25.16,231.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.76,232.27c-.35.43-1.23.33-1.87.46C22.27,232.61,23.14,231.16,23.76,232.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.93,232.11a.88.88,0,0,0-.16.62h-1.4C12.7,232.38,13.34,231.71,13.93,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.11,232.11c-.05.37-.54.29-.47.78H14.4A1.85,1.85,0,0,1,16.11,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,232.11a1.18,1.18,0,0,0,0,.94H16.43C16.79,232.58,17.09,232.05,18,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.86,232.11a1.51,1.51,0,0,1-1.72.94A2.3,2.3,0,0,1,19.86,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.3,153.63c.49,0,.68-.35,1.24-.31A14.48,14.48,0,0,0,21,156.13,3.8,3.8,0,0,1,18.3,153.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.11,154.57c1.29.63,2.57,2.62,3,4.68C22.58,158.19,22.26,156,21.11,154.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.33,157.22c2.08.63,3.15,4.44,3.89,6.4-1.23-.48-1.49-2.05-2-3.12S20.9,158.28,20.33,157.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.85,158.63c1.1.5,2,2.53,2.81,3.9-.05.36-.68.15-.78.46C26,161.77,25.68,159.93,24.85,158.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.72,88.73c-.16-2.91-.8-5.78.15-7.49-1.3.22-1-2-.46-2.81-1,.16-.7-.56-.78-.93-.43-1.82-.48-4-.78-6.09-.29-1.91-.71-3.8-1.1-5.77-.72-3.7-1.16-7.91-2.65-11.23-.34-.76-.93-1.31-1.25-2-1.07-2.44-1.46-5.41-2-8.27a123.15,123.15,0,0,1-2.19-18.57c-.16-3.43-.74-7.12-.31-10.14C14.56,13.78,16,10.94,15.42,9c-.83-2.84-7.34-2.8-9.2-.63a9.48,9.48,0,0,0,0,5.15c.24.87.8,1.47.93,2.18.35,1.89,0,4.27,0,6.4.13,6.32.44,12.72.16,18.72C7,48.42,5,55.85,3.88,63c-2.3,14.68-3,32.7.15,47.43,1.39,1.4,3.28,3.33,6.09,3.74,4,.59,10.23-.21,13-2a15.18,15.18,0,0,0,3-4.21c.48-1.64.16-4.17.16-6.4C26.19,96.76,25.94,92.75,25.72,88.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.58,8.54c.12.47-.26.46-.15.93a20.07,20.07,0,0,1-2,.63V8.54A4.47,4.47,0,0,1,10.58,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.52,8.69h.62v.63a1,1,0,0,1-.78.15C11.3,9.1,11.65,9.13,11.52,8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.21,10.41h.47c-.11.57.08,1.44-.78,1.25C11.19,11.43,10.92,10.64,11.21,10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.12,10.57c.11.57-.27.67-.16,1.24C9.27,11.69,9,12,8.4,12V10.88C9.09,10.89,9.32,10.44,10.12,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.77,10.88c.44-.13.4.22.78.15v.78c-.2.22-.68.16-1.09.16A5.58,5.58,0,0,1,12.77,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.35,69.38a1.29,1.29,0,0,1,.31.94c-1.24,1.26-2.62,2.37-3.9,3.59V72.35C19.33,72.34,20.17,70.3,21.35,69.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.66,71.57c.67,1.88-2.88,2.91-3.59,4.52-.35-.21-.05-1.08-.15-1.56C19.64,74.63,20.45,72.49,21.66,71.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.29,74.06c-.64,2.18-2.81,2.81-4.22,4.22V76.56C20,76.92,20.81,74.11,22.29,74.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.44,76.09c.23.14.23.51.31.78-1.17,1.64-3.14,2.48-4.36,4.06-.36-.27-.06-1.19-.16-1.72C19.93,78.46,21.05,77.14,22.44,76.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.75,78.43c1.16,1.65-.91,2.61-2,3.59a10,10,0,0,1-2.34,1.87V81.55C20.32,81,21.26,79.43,22.75,78.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.07,81.09c1.18,2.62-3.39,4.08-4.37,5.92-.31-.41-.08-1.37-.31-1.87A41.2,41.2,0,0,0,23.07,81.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.38,84.05c.35.22.06,1.09.15,1.56-1.7,1.31-3.24,2.78-4.83,4.21-.36-.26-.06-1.19-.16-1.71A54.89,54.89,0,0,0,23.38,84.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.38,86.7c.64,0,.16,1.09.31,1.56a55.71,55.71,0,0,0-4.84,4.21c-.42-.35-.29-1.26-.31-2C20.56,89.6,21.88,88.06,23.38,86.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.53,89.67c1,2.15-3.75,4.14-4.83,5.46V93.41C20.35,92.2,22,91,23.53,89.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.69,92.47c.31.22.08,1,.31,1.25-1.63,1.49-3.46,2.78-5.15,4.22-.35-.22-.05-1.09-.15-1.56A38.23,38.23,0,0,0,23.69,92.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.85,95.28c.35.17.06,1,.15,1.41-1.82,1.25-3.57,3.39-5.3,4.21V99.18A37.44,37.44,0,0,0,23.85,95.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.85,98.09c1.06,1.17-1.29,2.21-2.34,3.12S19.64,103,19,103.55c-.35-.16-.06-1-.16-1.4C20.66,100.93,22.19,99.46,23.85,98.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,100c.36.17.06,1,.16,1.41-2,1.11-3.58,3.49-5.31,4.37-.06-1.64,1.46-2.34,2.34-3.12A19.15,19.15,0,0,0,24,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.85,102.62c.68,0-.11.69.15,1.24-2.06,1.11-3.24,3.1-5.15,4.37,0-1.54,1.49-2.17,2.34-3A31.68,31.68,0,0,0,23.85,102.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.06,109.17c0-.13.06-.15.16-.16,2,.7,4.45,1,6.55,1.56.32.1,1-.19,1.09.16A46.42,46.42,0,0,1,6.68,110,5.9,5.9,0,0,0,6.06,109.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.46,112c.42-.1,2-.06,2.19.62A8.77,8.77,0,0,1,7.46,112Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,64.86a3.23,3.23,0,0,0,1.41-.16c-.26.87-1.49,1.32-.94,2.5,1.77,0,1.47-2.17,3-2.5A22.08,22.08,0,0,0,21.35,68c-1,1.38-2.73,2.06-3.43,3.74C17.33,69.71,17.33,67.11,17,64.86ZM17.92,70a2.32,2.32,0,0,0,1.4-2.34C18.65,68.17,17.37,68.8,17.92,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.14,14.31A118.56,118.56,0,0,0,14,41.46c1.32,7.43,4.22,13.93,5.61,20.9-1,.18-2,.38-3.12.47q-.8-6-2-11.54c-.32,3.85,1.09,8.15,1.09,11.7-2.28.16-4.71.18-7.18.15,2.06-12.22,3.84-26.51,2.34-41.34-.66,5.65-.2,13-.47,18.88C9.57,55.76,4.4,71.31,7,87.8c.84-1.68.46-3.84.46-5.78,0-5.85.36-12.18.78-17.79a39.74,39.74,0,0,0,7.65.63c2.3,13.15,1.56,28.87,1.4,43.84a22.61,22.61,0,0,1-11.54-1.56A193.53,193.53,0,0,1,6.84,60.65c1-7.28,2.19-14.82,2.34-22.47S9.67,22.4,9,14.47C9.64,13.81,11.23,14.3,12.14,14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70,179.69c-.4-5.88-.22-12.74-1.72-17.16-.95-2.82-2.91-4.84-4.83-6.87-1.31-1.38-3.7-2.82-4.22-4.21-.8-2.14-.71-5.08-.93-7.65s-.73-5.44-.32-8c.15-.9.77-1.82.94-2.81.44-2.59-.06-5.36.31-8-1.51-1.28-4.27-1.55-7-1.25-1.4.16-4.18.77-5,1.88-1.11,1.52-.77,5.61-.16,7.8.29,1,1.1,1.48,1.25,2.18.37,1.73-.15,5.7-.15,8.43,0,3,.53,6.37,0,8.27s-3,2.82-4.68,4.52A19.05,19.05,0,0,0,39.61,163c-1.09,3-.78,6.75-.78,10.46,0,2.63.05,5.26.16,8,.42,10.39.47,21,.94,31.21.38,8.4-.06,15.56,4.36,19.35,2.61,2.22,7.47,2.93,12.33,3,4.5,0,9.53-.6,11.7-2.81,2.82-2.86,2.34-10.78,2.65-15.91.4-6.6-.09-13-.15-18.41C70.75,191.67,70.46,185.91,70,179.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.16,125.86c.48,0-.1,1,.94.78-.7.48-1.57-.19-2.5,0C49.84,126.11,50.63,126.11,51.16,125.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56,126a6.57,6.57,0,0,1-3.59.62C53.46,126.19,54.44,125.55,56,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.59,128.2a7.91,7.91,0,0,1-4.83.16C50.8,127.69,53.17,128.66,54.59,128.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.87,128.51a3.86,3.86,0,0,1-2.5.94A4.2,4.2,0,0,1,57.87,128.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.35,129c.58.78,2.39.32,3.12.94C50.76,130.5,48.77,129.73,48.35,129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.44,129.45c.16.58-.53.31-.63.62C53.33,129.78,54,129.33,54.44,129.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.1,129.61H53c.15.66-.37.66-.93.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.56,130.07c.35.07.06.77.15,1.1a4.29,4.29,0,0,1-2.34.93v-1.4A13.7,13.7,0,0,0,57.56,130.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.51,130.54c.39,0,.48.25.78.31v1.25C48.52,132.09,48.49,131.34,48.51,130.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.12,131c.51.07.52,1.56-.31,1.25C53.8,131.72,53.73,131.14,54.12,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.22,131.17c.48.09,1.11,0,1.1.62s-.6.45-1.1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53,131.32c.15.77-.16,1.08-.93.94C52,131.49,52.26,131.18,53,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.4,132.88c-.1.83-1.51.37-1.87.94C54.93,132.91,56.81,133.13,57.4,132.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49,133c.37.14.41.63.46,1.09C48.82,134.23,49,133.54,49,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.38,133.35h.78c-.11.48.16.57.16.94h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.1,133.35a1.31,1.31,0,0,1,.93.16v.78H52.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.81,133.35h.47c0,.45,0,.85-.47.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.15,135.38c.14,0,.15.06.16.15,0,1.94.21,4.06.31,6.4.06,1.46.78,3.33-.31,4.06-.84-2.9-.5-7-.78-10.46C55.85,135.6,55.94,135.43,56.15,135.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.28,135.85c1,2.8.18,7.51,1.25,10.3a16.79,16.79,0,0,1-5.15.46c0-3.68,0-7.26.31-10.61A16.55,16.55,0,0,0,54.28,135.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.78,146.77c.48,0,.26.77.31,1.25a11.28,11.28,0,0,1-6.71.31c1.61-.57,3.82-.55,5.46-1.09a.88.88,0,0,1,.16.62C56.15,147.39,56.31,146.93,56.78,146.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.71,151.76c-1.43,1.79-5.18.94-7.33.94.31,1.57,3.93,1.15,6.24,1.25,1.9,3.2,3.61,6.58,5.3,10-5.25,1.68-12,1.24-17.47.16-.46.13.36.23.16.62a6.1,6.1,0,0,0-1.72-.16c.42,1.4,3.42,2.56,5.46,2.81,1.87.23,4-.17,6.09,0a25.71,25.71,0,0,0,.78,6.24,3.09,3.09,0,0,1-1.41.32c0-2.1-.36-3.9-.47-5.93-.63,1.4-.36,4.49.16,5.77-4.28.12-9.87.2-13-1.4.12-4.6-.2-8.1,1.72-10.46.64-.79,1.73-1.8,2.65-2.81,1.46-1.6,2.69-2.58,3.9-4.05a10.51,10.51,0,0,0,1.56-5,12,12,0,0,0,6.86-.63A11.54,11.54,0,0,1,57.71,151.76ZM42.27,164.24a.67.67,0,0,0,.62-1.09A.66.66,0,0,0,42.27,164.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.49,161.75c.57.2.58,1,.93,1.4C63.89,163.52,63.73,162.18,63.49,161.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.92,165c.18,0,.28,0,.31.16a7.13,7.13,0,0,1,.31,2.81c.12.69-.24,1.06-.15.15A20.85,20.85,0,0,0,66.92,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.45,165.18c.15,0,.12.19.16.31a15.5,15.5,0,0,0-.16,3.12c-.13,1.19-.2-.66-.16-1.09-.32-.4.06-1.51-.31-1.87C65.93,165.29,66.43,165.47,66.45,165.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.89,165.8h.47c-.21,2.5.34,5.06,0,7.18C65.11,170.86,64.47,167.55,64.89,165.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.64,166.12h.47c0,2.34-.06,4.73.16,6.86A14.7,14.7,0,0,1,63.64,166.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.08,166.43h.47c.13,1.68.13,4.58.31,6.71C62.25,171.25,62.38,168.63,62.08,166.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.46,166.58a40.43,40.43,0,0,0,.31,6.56H60.52c-.07-2.22-.28-4.3-.47-6.4C60.66,166.82,60.81,166.46,61.46,166.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.27,166.9c.24,2,.22,4.25.47,6.24-.62-.06-.86.27-1.56.15,0-2.23-.43-4.14-.62-6.24C57.89,166.76,58.7,167,59.27,166.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.78,167.05a23.42,23.42,0,0,0,.62,6.24c-.57.05-.72.53-1.4.47-.13-2.31-.68-4.21-.78-6.55A5.35,5.35,0,0,1,56.78,167.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.71,174.07c.73.2,1.44.43,2.18.63a6.4,6.4,0,0,1,.16,1.87,5.75,5.75,0,0,1-2.19-.94A4,4,0,0,0,40.71,174.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.39,174.07c.5-.13.32.41.62.47C67.84,175.28,66.79,174.55,67.39,174.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.76,174.54c-.05,1-1.53.91-2.34,1.09l-2.65.63c.12-.59-.19-.75-.16-1.25C63.32,174.94,65.35,174.38,66.76,174.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.83,174.85c.28,0,.33.19.62.16v1.71C43.72,176.63,43.88,175.63,43.83,174.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.23,175c.54-.13.6.23,1.09.15,0,.65-.27,1-.15,1.72C44.93,177.19,45.28,175.9,45.23,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.05,175h.47c-.1.47.2,1.34-.16,1.56C59.8,176.53,59.79,175.38,60.05,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59,175.16c-.12.75.25,1,.16,1.72-3.81.51-7.46.12-11.86.16v-1.72C51.44,175.51,54.88,175.33,59,175.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.17,175.79c.13,0,.14.06.15.15A297.9,297.9,0,0,1,69,210.11c-.42-11.23-1.22-22.91-1.25-34A1,1,0,0,1,68.17,175.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.61,176.41c.12,0,.15.16.31.16,0,11.69.63,22.77.78,34.32-7.42,2-20.21,2.36-25.9-1.4-.95-10.18-.58-21.68-.94-32.45C48,179.06,60.23,179.16,66.61,176.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42,211.52c.14,0,.15.06.16.15a46.28,46.28,0,0,0,6.4,1.88c.52.11,1.59-.44,1.56.62-2.17.34-6-.57-8.12-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.85,212.3c-.23.86-1.45.72-2.18,1.09C65.63,212.26,67.19,212.73,67.85,212.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.42,213.08c-.11.47.27.46.16.93-.46,0-.48.36-.94.31.08-.49-.28-.55-.15-1.09C63.67,213.05,64,213.06,64.42,213.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.71,213.55v1.09c-1.67.2-3.25.49-5,.62C59.33,214.74,60.59,213.05,62.71,213.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,213.7h.78v.94C51.06,214.79,50.91,214.36,51,213.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.88,213.7h4.36a11.89,11.89,0,0,1-4.36.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.07,223.84c-.32-2.74-.13-6-.62-8.58.23-.18.64-.19.78-.47C67.69,217.08,67.89,221.79,67.07,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42,215.11c2.56.28,5.63,1.32,8.43,1.56.7.06,1.47-.12,2.18,0,1,.16,2,.84,3.13.93,1.55.12,2.77-.29,4.36-.31-.22,1.89.43,3.73,0,5.3-.93-.26-.63-1.75-.78-2.81-.46.58.16,2.24-.31,2.81-1.83-.09-.74-3.1-1.56-4.21-.33,1.11.2,2.71,0,4.21-4,.52-8.47.59-11.7,1.88,3.72.34,7.85-1.1,11.86-.47-.09,1.69.09,3.13.15,4.68-4.31-.25-9.51-.17-12.63-1.41-2.39-.94-2.26-2.14-2.66-5.61A35.88,35.88,0,0,1,42,215.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.2,215.73c.62,1.77.32,5.3.16,7.33a37.35,37.35,0,0,1-.63-7.18C65,215.9,65.18,215.91,65.2,215.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.33,216.35c.41,1.58.78,4.83.16,6.4-.61-1.68-.46-4.12-.63-6.24C63.08,216.52,63.3,216.53,63.33,216.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61,217h.47a14.55,14.55,0,0,1,.31,5.61c-1.2-.77-.53-3.42-.78-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.34,223.84h.78c0,1.63.46,3.58.15,5C57.73,228.49,58.56,225,58.34,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.9,223.84c.25,0,.27.15.46.16-.32,2,.64,4.78-.31,5.46C60.26,228,59.78,225.2,59.9,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.3,224h.47c.37,1.53.61,4.76,0,6.24C61.12,228.65,61.58,226,61.3,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.33,224.47c.77.8.77,4.65,0,5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65,225.09c.88.47.48,3.73.32,4.21C64.65,228.51,65.24,226.4,65,225.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.92,226.18c.32.52,1.07,2.28,0,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.05,227.12c2.42,1.63,6,2.11,9.83,2.34-.14.49-.74.51-.94.93C48.37,229.91,44.44,229.78,43.05,227.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.43,229.3a.88.88,0,0,1-.78,1.09C58.52,229.64,58.85,229.34,59.43,229.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.71,229.61c-.44.39-.76.91-1.56.94-.14-.38.7-.8,0-.78A2.29,2.29,0,0,1,57.71,229.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.69,229.61c-.58.31-.93.85-1.88.78C54.06,229.76,54.64,229.45,55.69,229.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.92,230.39c.2.67-1.23,1.07-2,1.25C65.06,230.72,66.49,231.06,66.92,230.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.92,230.71c1.58,0,3.41,1.16,5.62,1.09,0,.36,0,.59.31.62A9.81,9.81,0,0,1,44.92,230.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,231.64c0,.56-.51.63-1.09.63a.91.91,0,0,0,.16-.63C63.56,231.77,63.68,231.35,64,231.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.55,232.27c-.35.43-1.22.33-1.87.46C61.06,232.61,61.94,231.16,62.55,232.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.72,232.11a.88.88,0,0,0-.16.62h-1.4C51.49,232.38,52.13,231.71,52.72,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.9,232.11c0,.37-.54.29-.46.78H53.19A1.85,1.85,0,0,1,54.9,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.78,232.11a1.1,1.1,0,0,0,0,.94H55.22C55.58,232.58,55.88,232.05,56.78,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.65,232.11a1.51,1.51,0,0,1-1.72.94A2.3,2.3,0,0,1,58.65,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.09,153.63c.5,0,.69-.35,1.25-.31a14.45,14.45,0,0,0,1.4,2.81A3.82,3.82,0,0,1,57.09,153.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.9,154.57c1.3.63,2.58,2.62,3,4.68C61.38,158.19,61.05,156,59.9,154.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.12,157.22c2.08.63,3.15,4.44,3.9,6.4-1.24-.48-1.49-2.05-2-3.12S59.69,158.28,59.12,157.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.64,158.63c1.11.5,2,2.53,2.81,3.9,0,.36-.68.15-.78.46C64.76,161.77,64.47,159.93,63.64,158.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.51,88.73c-.16-2.91-.8-5.78.16-7.49-1.31.22-1-2-.47-2.81-1,.16-.69-.56-.78-.93-.43-1.82-.47-4-.78-6.09-.28-1.91-.71-3.8-1.09-5.77-.73-3.7-1.16-7.91-2.66-11.23-.33-.76-.93-1.31-1.24-2-1.08-2.44-1.47-5.41-2-8.27a123.15,123.15,0,0,1-2.19-18.57c-.16-3.43-.74-7.12-.31-10.14.23-1.62,1.66-4.46,1.09-6.39-.83-2.84-7.34-2.8-9.2-.63a9.57,9.57,0,0,0,0,5.15c.25.87.8,1.47.93,2.18.36,1.89,0,4.27,0,6.4.13,6.32.44,12.72.16,18.72-.35,7.59-2.31,15-3.43,22.16-2.3,14.68-3,32.7.15,47.43,1.39,1.4,3.28,3.33,6.09,3.74,4,.59,10.24-.21,13-2a15.18,15.18,0,0,0,3-4.21c.48-1.64.16-4.17.16-6.4C65,96.76,64.73,92.75,64.51,88.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.38,8.54c.11.47-.27.46-.16.93a19.3,19.3,0,0,1-2,.63V8.54A4.51,4.51,0,0,1,49.38,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.31,8.69h.63v.63a1,1,0,0,1-.78.15C50.09,9.1,50.44,9.13,50.31,8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,10.41h.47c-.11.57.08,1.44-.78,1.25C50,11.43,49.71,10.64,50,10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.91,10.57c.11.57-.27.67-.16,1.24-.69-.12-.93.21-1.56.16V10.88C47.89,10.89,48.11,10.44,48.91,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.56,10.88c.44-.13.41.22.78.15v.78c-.2.22-.68.16-1.09.16A5.58,5.58,0,0,1,51.56,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.14,69.38a1.24,1.24,0,0,1,.31.94c-1.24,1.26-2.62,2.37-3.9,3.59V72.35C58.12,72.34,59,70.3,60.14,69.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.45,71.57c.67,1.88-2.88,2.91-3.58,4.52-.36-.21-.06-1.08-.16-1.56C58.43,74.63,59.24,72.49,60.45,71.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.08,74.06c-.63,2.18-2.81,2.81-4.21,4.22V76.56C58.75,76.92,59.61,74.11,61.08,74.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.23,76.09c.24.14.23.51.32.78-1.18,1.64-3.15,2.48-4.37,4.06-.36-.27-.06-1.19-.16-1.72C58.72,78.46,59.84,77.14,61.23,76.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.55,78.43c1.15,1.65-.91,2.61-2,3.59a9.84,9.84,0,0,1-2.34,1.87V81.55C59.12,81,60.05,79.43,61.55,78.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.86,81.09C63,83.71,58.47,85.17,57.49,87c-.31-.41-.08-1.37-.31-1.87A40.35,40.35,0,0,0,61.86,81.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.17,84.05c.36.22.06,1.09.16,1.56-1.71,1.31-3.25,2.78-4.84,4.21-.36-.26-.06-1.19-.16-1.71A54.89,54.89,0,0,0,62.17,84.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.17,86.7c.65,0,.16,1.09.31,1.56a55.58,55.58,0,0,0-4.83,4.21c-.43-.35-.3-1.26-.32-2C59.35,89.6,60.67,88.06,62.17,86.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.33,89.67c1,2.15-3.75,4.14-4.84,5.46V93.41C59.14,92.2,60.77,91,62.33,89.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.48,92.47c.31.22.09,1,.32,1.25-1.64,1.49-3.46,2.78-5.15,4.22-.36-.22-.06-1.09-.16-1.56A38.23,38.23,0,0,0,62.48,92.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.64,95.28c.35.17.06,1,.16,1.41-1.83,1.25-3.58,3.39-5.31,4.21V99.18A37.44,37.44,0,0,0,62.64,95.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.64,98.09c1.06,1.17-1.28,2.21-2.34,3.12s-1.87,1.81-2.5,2.34c-.35-.16-.06-1-.15-1.4C59.45,100.93,61,99.46,62.64,98.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.8,100c.35.17.05,1,.15,1.41-2,1.11-3.58,3.49-5.3,4.37-.06-1.64,1.45-2.34,2.34-3.12A19.66,19.66,0,0,0,62.8,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.64,102.62c.68,0-.11.69.16,1.24-2.07,1.11-3.25,3.1-5.15,4.37,0-1.54,1.49-2.17,2.34-3A33.13,33.13,0,0,0,62.64,102.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.85,109.17c0-.13.06-.15.16-.16,2,.7,4.45,1,6.55,1.56.32.1,1-.19,1.09.16a46.15,46.15,0,0,1-7.17-.78A6.92,6.92,0,0,0,44.85,109.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.26,112c.41-.1,2-.06,2.18.62A8.69,8.69,0,0,1,46.26,112Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.77,64.86a3.23,3.23,0,0,0,1.41-.16c-.26.87-1.49,1.32-.94,2.5,1.77,0,1.47-2.17,3-2.5A20.94,20.94,0,0,0,60.14,68c-1,1.38-2.73,2.06-3.43,3.74C56.12,69.71,56.12,67.11,55.77,64.86ZM56.71,70a2.32,2.32,0,0,0,1.4-2.34C57.45,68.17,56.16,68.8,56.71,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.94,14.31a118.58,118.58,0,0,0,1.87,27.15c1.33,7.43,4.22,13.93,5.62,20.9-1,.18-2,.38-3.12.47q-.81-6-2-11.54C53,55.14,54.37,59.44,54.37,63c-2.28.16-4.71.18-7.18.15C49.25,50.92,51,36.63,49.53,21.8c-.66,5.65-.19,13-.47,18.88-.7,15.08-5.87,30.63-3.27,47.12.84-1.68.47-3.84.47-5.78,0-5.85.35-12.18.78-17.79a39.57,39.57,0,0,0,7.64.63C57,78,56.24,93.73,56.09,108.7a22.63,22.63,0,0,1-11.55-1.56,194,194,0,0,1,1.09-46.49c1-7.28,2.19-14.82,2.34-22.47s.49-15.78-.15-23.71C48.43,13.81,50,14.3,50.94,14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.77,179.69c-.4-5.88-.22-12.74-1.72-17.16-1-2.82-2.91-4.84-4.83-6.87-1.31-1.38-3.69-2.82-4.22-4.21-.8-2.14-.71-5.08-.93-7.65s-.73-5.44-.31-8c.14-.9.77-1.82.93-2.81.44-2.59-.06-5.36.31-8-1.51-1.28-4.27-1.55-7-1.25-1.4.16-4.18.77-5,1.88-1.11,1.52-.77,5.61-.15,7.8.28,1,1.09,1.48,1.24,2.18.37,1.73-.15,5.7-.15,8.43,0,3,.53,6.37,0,8.27s-3,2.82-4.68,4.52a18.86,18.86,0,0,0-3.9,6.08c-1.1,3-.78,6.75-.78,10.46,0,2.63,0,5.26.15,8,.42,10.39.47,21,.94,31.21C78,221,77.6,228.17,82,232c2.6,2.22,7.46,2.93,12.32,3,4.51,0,9.53-.6,11.7-2.81,2.82-2.86,2.34-10.78,2.65-15.91.41-6.6-.09-13-.15-18.41C108.49,191.67,108.19,185.91,107.77,179.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.89,125.86c.48,0-.09,1,.94.78-.7.48-1.57-.19-2.5,0C87.58,126.11,88.36,126.11,88.89,125.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.73,126a6.56,6.56,0,0,1-3.59.62C91.19,126.19,92.17,125.55,93.73,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.32,128.2a7.91,7.91,0,0,1-4.83.16C88.53,127.69,90.9,128.66,92.32,128.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.6,128.51a3.84,3.84,0,0,1-2.5.94A4.22,4.22,0,0,1,95.6,128.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.08,129c.58.78,2.39.32,3.12.94C88.49,130.5,86.5,129.73,86.08,129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.17,129.45c.16.58-.53.31-.63.62C91.06,129.78,91.72,129.33,92.17,129.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.83,129.61h.93c.15.66-.37.66-.93.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.29,130.07c.35.07.06.77.15,1.1a4.29,4.29,0,0,1-2.34.93v-1.4A13.7,13.7,0,0,0,95.29,130.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.24,130.54c.39,0,.48.25.78.31v1.25C86.25,132.09,86.22,131.34,86.24,130.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.86,131c.5.07.51,1.56-.32,1.25C91.53,131.72,91.46,131.14,91.86,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88,131.17c.49.09,1.11,0,1.1.62s-.6.45-1.1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.76,131.32c.15.77-.16,1.08-.93.94C89.68,131.49,90,131.18,90.76,131.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.13,132.88c-.1.83-1.51.37-1.87.94C92.66,132.91,94.54,133.13,95.13,132.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.71,133c.37.14.41.63.46,1.09C86.55,134.23,86.73,133.54,86.71,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.11,133.35h.78c-.11.48.16.57.16.94h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.83,133.35a1.31,1.31,0,0,1,.93.16v.78h-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.54,133.35H92c0,.45,0,.85-.47.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.88,135.38c.14,0,.15.06.16.15,0,1.94.21,4.06.31,6.4.07,1.46.78,3.33-.31,4.06-.84-2.9-.49-7-.78-10.46C93.59,135.6,93.67,135.43,93.88,135.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92,135.85c1,2.8.18,7.51,1.25,10.3a16.79,16.79,0,0,1-5.15.46c0-3.68,0-7.26.31-10.61A16.55,16.55,0,0,0,92,135.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.51,146.77c.48,0,.26.77.31,1.25a11.28,11.28,0,0,1-6.71.31c1.61-.57,3.82-.55,5.46-1.09a.88.88,0,0,1,.16.62C93.88,147.39,94,146.93,94.51,146.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.44,151.76c-1.43,1.79-5.18.94-7.33.94.31,1.57,3.94,1.15,6.24,1.25,1.9,3.2,3.61,6.58,5.31,10-5.26,1.68-12,1.24-17.48.16-.46.13.36.23.16.62a6.1,6.1,0,0,0-1.72-.16c.42,1.4,3.42,2.56,5.46,2.81,1.87.23,4-.17,6.09,0A25.71,25.71,0,0,0,93,173.6a3.09,3.09,0,0,1-1.41.32c0-2.1-.36-3.9-.46-5.93-.64,1.4-.37,4.49.15,5.77-4.28.12-9.87.2-13-1.4.12-4.6-.19-8.1,1.72-10.46.64-.79,1.73-1.8,2.65-2.81,1.46-1.6,2.69-2.58,3.9-4.05a10.51,10.51,0,0,0,1.56-5,12,12,0,0,0,6.87-.63A11.55,11.55,0,0,1,95.44,151.76ZM80,164.24a.67.67,0,0,0,.62-1.09A.66.66,0,0,0,80,164.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.22,161.75c.57.2.58,1,.93,1.4C101.62,163.52,101.46,162.18,101.22,161.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.65,165c.18,0,.28,0,.31.16a7.13,7.13,0,0,1,.31,2.81c.12.69-.24,1.06-.15.15A20.85,20.85,0,0,0,104.65,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.18,165.18c.15,0,.12.19.16.31a15.5,15.5,0,0,0-.16,3.12c-.13,1.19-.2-.66-.16-1.09-.32-.4.06-1.51-.31-1.87C103.67,165.29,104.16,165.47,104.18,165.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.62,165.8h.47c-.2,2.5.34,5.06,0,7.18C102.84,170.86,102.2,167.55,102.62,165.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.37,166.12h.47c0,2.34,0,4.73.16,6.86A14.7,14.7,0,0,1,101.37,166.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.81,166.43h.47c.13,1.68.13,4.58.31,6.71C100,171.25,100.11,168.63,99.81,166.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.19,166.58a40.43,40.43,0,0,0,.31,6.56H98.25c-.07-2.22-.28-4.3-.47-6.4C98.39,166.82,98.55,166.46,99.19,166.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97,166.9c.24,2,.22,4.25.47,6.24-.62-.06-.86.27-1.56.15,0-2.23-.43-4.14-.62-6.24C95.62,166.76,96.43,167,97,166.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.51,167.05a23.84,23.84,0,0,0,.62,6.24c-.57.05-.72.53-1.4.47-.13-2.31-.68-4.21-.78-6.55A5.35,5.35,0,0,1,94.51,167.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.44,174.07c.74.2,1.44.43,2.18.63a6.4,6.4,0,0,1,.16,1.87,5.82,5.82,0,0,1-2.19-.94A4,4,0,0,0,78.44,174.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.12,174.07c.5-.13.32.41.62.47C105.57,175.28,104.52,174.55,105.12,174.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.49,174.54c0,1-1.53.91-2.34,1.09l-2.65.63c.12-.59-.19-.75-.16-1.25C101.05,174.94,103.08,174.38,104.49,174.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.56,174.85c.28,0,.33.19.62.16v1.71C81.45,176.63,81.61,175.63,81.56,174.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83,175c.54-.13.6.23,1.09.15,0,.65-.27,1-.15,1.72C82.66,177.19,83,175.9,83,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.78,175h.47c-.1.47.2,1.34-.15,1.56C97.53,176.53,97.52,175.38,97.78,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.69,175.16c-.12.75.25,1,.16,1.72-3.81.51-7.46.12-11.86.16v-1.72C89.17,175.51,92.61,175.33,96.69,175.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.9,175.79c.13,0,.14.06.15.15a297.9,297.9,0,0,1,.63,34.17c-.42-11.23-1.22-22.91-1.25-34A1,1,0,0,1,105.9,175.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.34,176.41c.12,0,.15.16.31.16,0,11.69.64,22.77.78,34.32-7.42,2-20.21,2.36-25.9-1.4-1-10.18-.58-21.68-.94-32.45C85.75,179.06,98,179.16,104.34,176.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.69,211.52c.13,0,.14.06.15.15a46.28,46.28,0,0,0,6.4,1.88c.52.11,1.59-.44,1.56.62-2.17.34-6-.57-8.11-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.59,212.3c-.24.86-1.46.72-2.19,1.09C103.36,212.26,104.93,212.73,105.59,212.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.15,213.08c-.11.47.27.46.16.93-.46,0-.48.36-.94.31.08-.49-.28-.55-.15-1.09C101.4,213.05,101.77,213.06,102.15,213.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.44,213.55v1.09c-1.67.2-3.25.49-5,.62C97.07,214.74,98.32,213.05,100.44,213.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.74,213.7h.78v.94C88.79,214.79,88.64,214.36,88.74,213.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.61,213.7H95a12,12,0,0,1-4.37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.8,223.84c-.32-2.74-.13-6-.62-8.58.23-.18.64-.19.78-.47C105.43,217.08,105.62,221.79,104.8,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.69,215.11c2.55.28,5.62,1.32,8.42,1.56.7.06,1.48-.12,2.18,0,1,.16,2,.84,3.13.93,1.55.12,2.78-.29,4.36-.31-.22,1.89.43,3.73,0,5.3-.93-.26-.63-1.75-.78-2.81-.46.58.16,2.24-.31,2.81-1.83-.09-.74-3.1-1.56-4.21-.33,1.11.2,2.71,0,4.21-4,.52-8.46.59-11.7,1.88,3.72.34,7.85-1.1,11.86-.47-.09,1.69.1,3.13.15,4.68-4.31-.25-9.51-.17-12.63-1.41-2.39-.94-2.26-2.14-2.66-5.61A35.06,35.06,0,0,1,79.69,215.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.93,215.73c.62,1.77.32,5.3.16,7.33a37.35,37.35,0,0,1-.63-7.18C102.69,215.9,102.91,215.91,102.93,215.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.06,216.35c.41,1.58.78,4.83.16,6.4-.61-1.68-.46-4.12-.63-6.24C100.81,216.52,101,216.53,101.06,216.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.72,217h.47a14.35,14.35,0,0,1,.31,5.61c-1.2-.77-.53-3.42-.78-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.07,223.84h.78c0,1.63.46,3.58.15,5C95.46,228.49,96.29,225,96.07,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.63,223.84c.25,0,.27.15.47.16-.33,2,.63,4.78-.32,5.46C98,228,97.51,225.2,97.63,223.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99,224h.47c.37,1.53.61,4.76,0,6.24C98.86,228.65,99.31,226,99,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.06,224.47c.77.8.77,4.65,0,5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.78,225.09c.88.47.47,3.73.31,4.21C102.38,228.51,103,226.4,102.78,225.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.65,226.18c.32.52,1.08,2.28,0,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.78,227.12c2.43,1.63,6,2.11,9.83,2.34-.14.49-.74.51-.94.93C86.1,229.91,82.17,229.78,80.78,227.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.16,229.3a.88.88,0,0,1-.78,1.09C96.25,229.64,96.58,229.34,97.16,229.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.44,229.61c-.44.39-.76.91-1.56.94-.14-.38.7-.8,0-.78A2.29,2.29,0,0,1,95.44,229.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.42,229.61c-.58.31-.93.85-1.88.78C91.79,229.76,92.37,229.45,93.42,229.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.65,230.39c.2.67-1.23,1.07-2,1.25C102.79,230.72,104.22,231.06,104.65,230.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.65,230.71c1.58,0,3.41,1.16,5.62,1.09,0,.36,0,.59.31.62A9.81,9.81,0,0,1,82.65,230.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.68,231.64c0,.56-.51.63-1.09.63a.91.91,0,0,0,.16-.63C101.29,231.77,101.41,231.35,101.68,231.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.28,232.27c-.35.43-1.22.33-1.87.46C98.79,232.61,99.67,231.16,100.28,232.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.45,232.11a.88.88,0,0,0-.16.62h-1.4C89.22,232.38,89.86,231.71,90.45,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.64,232.11c0,.37-.55.29-.47.78H90.92A1.86,1.86,0,0,1,92.64,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.51,232.11a1.1,1.1,0,0,0,0,.94H93C93.31,232.58,93.61,232.05,94.51,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.38,232.11a1.51,1.51,0,0,1-1.72.94A2.3,2.3,0,0,1,96.38,232.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.82,153.63c.5,0,.69-.35,1.25-.31a14.45,14.45,0,0,0,1.4,2.81A3.82,3.82,0,0,1,94.82,153.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.63,154.57c1.3.63,2.58,2.62,3,4.68C99.11,158.19,98.78,156,97.63,154.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.85,157.22c2.08.63,3.15,4.44,3.9,6.4-1.23-.48-1.49-2.05-2-3.12S97.42,158.28,96.85,157.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.37,158.63c1.11.5,2,2.53,2.81,3.9-.05.36-.68.15-.78.46C102.49,161.77,102.2,159.93,101.37,158.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.24,88.73c-.16-2.91-.8-5.78.16-7.49-1.31.22-1-2-.47-2.81-1,.16-.69-.56-.78-.93-.43-1.82-.47-4-.78-6.09-.28-1.91-.71-3.8-1.09-5.77-.73-3.7-1.16-7.91-2.65-11.23-.34-.76-.94-1.31-1.25-2-1.08-2.44-1.46-5.41-2-8.27a123.15,123.15,0,0,1-2.19-18.57c-.16-3.43-.74-7.12-.31-10.14.23-1.62,1.66-4.46,1.09-6.39-.83-2.84-7.34-2.8-9.2-.63a9.67,9.67,0,0,0,0,5.15c.25.87.8,1.47.94,2.18.35,1.89-.05,4.27,0,6.4.12,6.32.43,12.72.15,18.72-.35,7.59-2.31,15-3.43,22.16-2.3,14.68-3,32.7.16,47.43,1.38,1.4,3.27,3.33,6.08,3.74,4,.59,10.24-.21,13-2a15.18,15.18,0,0,0,3-4.21c.48-1.64.16-4.17.16-6.4C102.71,96.76,102.46,92.75,102.24,88.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.11,8.54c.11.47-.27.46-.16.93a19.3,19.3,0,0,1-2,.63V8.54A4.51,4.51,0,0,1,87.11,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88,8.69h.63v.63a1,1,0,0,1-.78.15C87.82,9.1,88.17,9.13,88,8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.73,10.41h.47c-.1.57.09,1.44-.78,1.25C87.71,11.43,87.44,10.64,87.73,10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.64,10.57c.11.57-.27.67-.16,1.24-.69-.12-.93.21-1.56.16V10.88C85.62,10.89,85.84,10.44,86.64,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.29,10.88c.44-.13.41.22.78.15v.78c-.2.22-.68.16-1.09.16A5.58,5.58,0,0,1,89.29,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.87,69.38a1.29,1.29,0,0,1,.32.94c-1.25,1.26-2.63,2.37-3.9,3.59V72.35C95.85,72.34,96.7,70.3,97.87,69.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.19,71.57c.67,1.88-2.89,2.91-3.59,4.52-.36-.21-.06-1.08-.16-1.56C96.16,74.63,97,72.49,98.19,71.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.81,74.06c-.63,2.18-2.81,2.81-4.21,4.22V76.56C96.48,76.92,97.34,74.11,98.81,74.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99,76.09c.23.14.22.51.31.78-1.18,1.64-3.15,2.48-4.37,4.06-.36-.27-.06-1.19-.16-1.72C96.45,78.46,97.57,77.14,99,76.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.28,78.43c1.15,1.65-.91,2.61-2,3.59a9.84,9.84,0,0,1-2.34,1.87V81.55C96.85,81,97.78,79.43,99.28,78.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.59,81.09c1.18,2.62-3.39,4.08-4.37,5.92-.31-.41-.08-1.37-.31-1.87A40.35,40.35,0,0,0,99.59,81.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.9,84.05c.36.22.06,1.09.16,1.56-1.7,1.31-3.25,2.78-4.84,4.21-.36-.26-.06-1.19-.16-1.71A54.89,54.89,0,0,0,99.9,84.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.9,86.7c.65,0,.16,1.09.31,1.56a55.58,55.58,0,0,0-4.83,4.21c-.43-.35-.29-1.26-.32-2C97.08,89.6,98.4,88.06,99.9,86.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.06,89.67c1,2.15-3.75,4.14-4.84,5.46V93.41C96.87,92.2,98.5,91,100.06,89.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.21,92.47c.31.22.09,1,.32,1.25-1.64,1.49-3.46,2.78-5.15,4.22-.36-.22-.06-1.09-.16-1.56A37.57,37.57,0,0,0,100.21,92.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.37,95.28c.35.17.06,1,.16,1.41-1.83,1.25-3.58,3.39-5.31,4.21V99.18A37.44,37.44,0,0,0,100.37,95.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.37,98.09c1.06,1.17-1.28,2.21-2.34,3.12s-1.87,1.81-2.5,2.34c-.35-.16-.06-1-.15-1.4C97.18,100.93,98.72,99.46,100.37,98.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.53,100c.35.17,0,1,.15,1.41-2,1.11-3.58,3.49-5.3,4.37-.06-1.64,1.45-2.34,2.34-3.12A19.66,19.66,0,0,0,100.53,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.37,102.62c.68,0-.11.69.16,1.24-2.07,1.11-3.25,3.1-5.15,4.37,0-1.54,1.49-2.17,2.34-3A33.13,33.13,0,0,0,100.37,102.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.58,109.17c0-.13.06-.15.16-.16,2,.7,4.45,1,6.55,1.56.33.1,1-.19,1.1.16a46.29,46.29,0,0,1-7.18-.78A6,6,0,0,0,82.58,109.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84,112c.41-.1,2-.06,2.18.62A8.69,8.69,0,0,1,84,112Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.51,64.86a3.2,3.2,0,0,0,1.4-.16c-.26.87-1.49,1.32-.94,2.5,1.77,0,1.47-2.17,3-2.5A20.94,20.94,0,0,0,97.87,68c-1,1.38-2.73,2.06-3.43,3.74C93.86,69.71,93.85,67.11,93.51,64.86ZM94.44,70a2.32,2.32,0,0,0,1.4-2.34C95.18,68.17,93.89,68.8,94.44,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.67,14.31a118.58,118.58,0,0,0,1.87,27.15c1.33,7.43,4.22,13.93,5.62,20.9-1,.18-2,.38-3.12.47q-.81-6-2-11.54c-.32,3.85,1.09,8.15,1.09,11.7-2.28.16-4.7.18-7.18.15C87,50.92,88.76,36.63,87.26,21.8c-.65,5.65-.19,13-.46,18.88-.71,15.08-5.87,30.63-3.28,47.12C84.36,86.12,84,84,84,82c0-5.85.35-12.18.78-17.79a39.57,39.57,0,0,0,7.64.63C94.71,78,94,93.73,93.82,108.7a22.63,22.63,0,0,1-11.55-1.56,194,194,0,0,1,1.09-46.49c1-7.28,2.19-14.82,2.34-22.47s.5-15.78-.15-23.71C86.16,13.81,87.75,14.3,88.67,14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.47,123.05c.12-.82-.65-1.06-.85-.81C119.52,123.49,119.88,122.84,120.47,123.05Zm106.24-7.87c0-1.66-1.71-1.45-2.37-2.37.69-2.42,2.27-3.28,3.4-5.56-1,.68-1,.46-1.83-.47-.91,1.25-1.17,1.24-2.34.85-.42,1.18-.84,2.38-1.61,2.81-.24-.33-.68-.41-.42-1.28-8.79-7.83-20.07-14.2-27.9-21.57a19.5,19.5,0,0,1,.12-4.65c-.66-.24-.66-.58-1.28-.33-.36,1.33,0,3.14-.39,3.7-1.06-.25-.79-2-1.62-2.47-1.89,1.56-5-5.39-6.23-1.32.12.57,1.15-.13.45,1,1.69.21,2.48,1.43,3.29,2.61a3,3,0,0,0-.82,2.42c3.24.24,4.64,3.56,4.35,8.44-1.58.17-3,.7-4.89.2-1.4.95-3.51,1-5.57,1.19-1.25.11-2.84-.89-3.8.48.9,2.15,2.11,1.11,3.28.85a30.39,30.39,0,0,1,10.89-.11c0,1,.88,1,.7,2.24a230.51,230.51,0,0,0-29.35.87,14.18,14.18,0,0,1-2.43,0c-4.49-.47-8-.26-12-1.64a10.37,10.37,0,0,0-2-.53c-6.28-.82-11.84.61-17.77-2.26-.73-.85-.39-2.9-1.31-3.56-.79-.09-.56,2-1.33,2-.55-.49,0-2.19-1.1-2-.89.24-.33,1.7-.82,2.42-1-.06-1.6-1.23-2.22-.28-.21,1.57,1.24,1.29,1.64,2.18a7.29,7.29,0,0,0-2.4-.33c-.2,1.41-1.27,1.69-.91,3.27,1,1.38,2.05.15,3-.38.8,3.38-2.24.81-2.71,2.52-.17,2.39,2.93-.31,2.77,2.18-.8.58-2.5-.78-2.89.71-.36.49,0,.37-.12,1.14.78,1,2.1.48,3,.47-.08,5,.08,9.79-.51,15.38-1.19.91-3.35-.29-4.41.9.15,2.56,2.36.16,3.19,1.71-.68.79-2.93-.2-2.76,1.33.86,1.92,2.52-.29,3.74.09,1,1.56-.41,5.46.06,6.45,1-.13.94-2.63,1.67-3.36.11-1.41.55-2.08.58-3.66,15.88-6.38,34.16-4.34,53.23-3.18a9.76,9.76,0,0,1,4.38,1.14c-4.08,1.06-7.61,1.78-11.68.48,7.35,5.56,13.88-4.19,20.92,2.5-.5,4.85.73,12.7-.54,17.41-.7,2.63-2.72,2.29-3.65,4.33-.15,1.09.12,1.71.73,1.94.67,0,.58-1.54,1-2.09,0,1.17.75,1.5,1.06,2.33-.06,2.51-.62,4.69.89,5.79.65-2.06.42-4.53.75-7.12.31-.63.89-.63.95-1.81,1.41-.38,1.79-2.33,2.64-3.7,2.45-3.9,5.9-5.68,8.82-8.83,5.34-5.78,9.62-13.84,15.17-19.19.38,0,1.49-.22,1-.9,0,.29-.35.28-.36-.09C221.53,114.33,225.31,115.36,226.71,115.18ZM202.46,98.07A85.33,85.33,0,0,1,213,106.65c-3.54-1.82-7.26-5.62-10.53-8.58C201.67,98.14,202.52,97.21,202.46,98.07Zm-.48-.71c-2.15-.62-4.41-3.29-6.64-4.65C198,92.72,199.7,96.05,202,97.36Zm-7.61,2.7a2.51,2.51,0,0,1-.33-2.13C194.45,98.3,194.4,99.2,194.37,100.06Zm-.73-5.45c.28.79.74,1.52.3,2.42C193.5,96.61,193.47,95.72,193.64,94.61ZM125.7,121.48c-.53-3,.63-7.81.7-11.82,0-.66.39-.31.45-.76.46.14.41,1.36-.27.81C127.15,113.9,126.83,116.78,125.7,121.48Zm11.52-18.38c.45,0,.7-.47,1.19-.57,5.88-1.16,13.21,2.07,19.5,1.84a114.77,114.77,0,0,1-19.77.72,46.72,46.72,0,0,1-8.55-.75,9.78,9.78,0,0,0,.09-2.6C132.69,101.52,134.76,103,137.22,103.1Zm48.13,20.08c-6.29-.77-13.42-2-19.65-2.16,8.23-1.8,17.63.83,25.55,1.35l.54.14C190.27,125.16,187.5,123.45,185.35,123.18Zm8.85,19c.27-4.75-.14-10,.82-14.71,1,.06,4,1.89,4.84.38-1.29-1.68-2.41-2.68-4.57-2.94.11-.7.18-1.37-.21-1.52,1.24-.24,3.21,1.66,3.95-.14-.63-2.47-5.12-.64-5.44-3.46-.8-.45-.9.6-1.4.8-23-3.3-43.58-.36-64.57,2.29,1-4.67,1.06-11.79,2.18-15.23,10.66.1,21.08-1.23,32-.79,5.65.23,12.27-.06,18.34.37,4.47.31,9.4-1.72,13.47.27,1.11,1.52,0,5.54,1.13,7,.66-1.57-.08-6.11,1.09-8.49,1.58.16,3.29.63,4-1-.76-2.49-3.48-.55-4.69-1.8.16-1.24-.15-2,0-3.8,0-1.48.64.79.76-.1.58-1.73-.82-1.25-.88-2.27s.39-1.71.12-2.9c7.49,5,13.3,11.94,20.9,16.83-2.65,5.09-6.88,6.74-9.51,11.88-1.74.79-3.91,4.35-6.18,6.88-1,1.16-4.45,3.17-4.22,4.46.49,2.86,2.43-.57,3.47-.86.85-1.52,1.8-2.84,3.16-3.27,3.77-5.23,8-9.54,12-14.15,1.3-.67,2.28-4.19,3.8-2.24C210.72,123.68,203,134.16,194.2,142.15Zm-33.79-17.24c-.33-.67-1-2-1.59-1-6.31-1.23-12.38.91-18.31,1.1-4,.13-8.1-.54-11.13,2.38,1.08.56,1.9.55,2.83,1.62,2.87-1.7,6.85-2.36,10.95-2.43,5-.1,10.37-.87,14.69-.59a6.2,6.2,0,0,1,3.77,1.57c0-1.15,1-.08.92-1.52C162.48,124.94,161.11,125.3,160.41,124.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingSpace);
export default __webpack_public_path__ + "static/media/saving-space.1ceadb1ec34f2b0fba554b7f877b3011.svg";
export { ForwardRef as ReactComponent };